import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A1F40] border-t border-white/[0.06] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex flex-col items-start leading-none mb-6">
              <span className="font-brand text-lg tracking-[0.08em] text-white">
                ArcPoint
              </span>
              <span className="text-[10px] uppercase tracking-[0.32em] text-slate-300/70 mt-1.5">
                Executive Search
              </span>
            </div>
            <p className="text-sm text-slate-300/70 max-w-md leading-relaxed mt-6">
              Founder-led, UK-focused executive search for ambitious founders,
              scaling SaaS businesses and SMEs. Retained search across CEO,
              COO, CCO, CRO and commercial leadership mandates.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono-eyebrow text-slate-300/70 mb-5">Practice</div>
            <ul className="space-y-3 text-sm text-slate-200/90">
              <li>Executive Search</li>
              <li>Commercial Leadership</li>
              <li>Talent Advisory</li>
              <li>
                <Link
                  to="/people"
                  data-testid="footer-people-link"
                  className="hover:text-[#C9A876] transition-colors"
                >
                  People
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="font-mono-eyebrow text-slate-300/70 mb-5">Contact</div>
            <ul className="space-y-3 text-sm text-slate-200/90">
              <li>
                <a
                  data-testid="footer-email"
                  href="mailto:owen@arcpointgroup.co.uk"
                  className="hover:text-[#C9A876] transition-colors"
                >
                  owen@arcpointgroup.co.uk
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-phone"
                  href="tel:+447503410642"
                  className="hover:text-[#C9A876] transition-colors"
                >
                  +44 7503 410642
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-linkedin"
                  href="https://www.linkedin.com/in/owen-peterson-executive-search"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#C9A876] transition-colors"
                >
                  LinkedIn — Owen Peterson
                </a>
              </li>
              <li>United Kingdom</li>
            </ul>
          </div>
        </div>

        <div className="hairline my-12" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.22em] text-slate-400/70">
          <div>© {year} ArcPoint Executive Search · All rights reserved</div>
          <div className="flex items-center gap-8">
            <span>Discreet · Founder-led · UK</span>
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="hover:text-[#C9A876] transition-colors"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
